import { render, staticRenderFns } from "./dynamicCodeStaff.vue?vue&type=template&id=31cbb1bf&"
import script from "./dynamicCodeStaff.vue?vue&type=script&lang=js&"
export * from "./dynamicCodeStaff.vue?vue&type=script&lang=js&"
import style0 from "./dynamicCodeStaff.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports